import React from "react"
import styled from "styled-components"

import { ErrorIcon } from "../../../../components/Icon"
import { PageContainer } from "../../../../components/Page"
import { ERROR_COLOR } from "../../../../helpers/styles"
import { usePaymentState } from "../../components/PaymentContext"
import {
  PaymentPageContactDescription,
  PaymentPageDescription,
  PaymentPageHeadline,
  PaymentPageTitle,
} from "../../components/PaymentPage"

const StyledTitle = styled(PaymentPageTitle)`
  color: ${ERROR_COLOR};
`

export const CancelledPage: React.FunctionComponent = () => {
  const { paymentSummary } = usePaymentState()

  if (!paymentSummary) {
    return null
  }

  return (
    <PageContainer showPoweredBy={true}>
      <PaymentPageHeadline>Something went wrong!</PaymentPageHeadline>
      <PaymentPageDescription>The payment link was cancelled.</PaymentPageDescription>
      <ErrorIcon />
      <StyledTitle>Payment Link Cancelled</StyledTitle>
      <PaymentPageContactDescription>
        Please contact {paymentSummary.name} for any questions
      </PaymentPageContactDescription>
    </PageContainer>
  )
}
